/* eslint-disable @typescript-eslint/no-explicit-any */
import {Box, Typography} from '@mui/material';

import {CrossOutlined, Dot} from '@jobseeker/lotus/assets/icons';
import {Image} from '@jobseeker/lotus/components/Image';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import dynamic from 'next/dynamic';
import {Link} from '../../UtilityComponents';
import {ButtonV2} from '@jobseeker/lotus/elements';
import type {JobDetail as JB} from '@jobseeker/common-core/stateModels/job/jobdetail.models';
import type {AppState} from '@jobseeker/common-core/types';
import {useDispatch, useSelector} from 'react-redux';
import kebabCase from 'lodash/kebabCase';
import {getOldLink} from '@jobseeker/lotus/utils';
import {ApplyJobInternal} from '../../UserJobApplication';
import {Loader} from '@jobseeker/lotus/components';
import {useState} from 'react';
import PopUpDialog from './Dialog';
import BottomSheetDialog from '@jobseeker/lotus/elements/BottomSheet';
import {getKeyFromPath, TrackEventUBA} from '@jobseeker/common-core/utils';

export const Header = (props: any) => {
  const detail: JB = useSelector((state: AppState) => state.jobDetail);
  const location = detail.location ?? detail.locations;
  return (
    <Box pb={{xxs: 1, md: 0}}>
      <Box
        // ref={header}
        sx={{background: '#91B87929', py: 2, px: {xxs: 2, md: 3}}}
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography variant="subtitle1" fontSize={{xxs: 18, md: 18}}>
          Review & Submit
        </Typography>{' '}
        <Box sx={{cursor: 'pointer'}} onClick={props.onClose}>
          <Image
            src={CrossOutlined}
            alt={'CrossOutlined'}
            width={20}
            height={20}
            objectFit="cover"
          />
        </Box>
      </Box>

      <Box mx={{xxs: 2, md: 3}} mt={2}>
        <Box
          sx={{
            border: '1px solid',
            p: 2,
            borderColor: 'primary.main',
            borderRadius: 4,
            mb: 2,
          }}
        >
          <Typography variant="subtitle1" mb={1}>
            You are Applying to: {detail.title}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              columnGap: 1.5,
              color: 'text.secondary',
              flexWrap: 'wrap',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: 'fit-content',
                gap: 0.4,
                flexWrap: 'wrap',
              }}
            >
              <Typography component={'span'} variant="subtitle2">
                {`${detail.min}-${detail.max} Yrs`}
              </Typography>
              <Typography lineHeight={0} component={'span'} variant="body2">
                <Image
                  src={Dot}
                  width={4}
                  height={4}
                  alt="."
                  style={{margin: '0 8px'}}
                />
              </Typography>
              <Typography component={'span'} variant="subtitle2">
                {location?.length > 3
                  ? 'Multiple Locations'
                  : location?.map(l => l.name).join(', ')}
              </Typography>
            </Box>
            <Typography component={'p'} color="text.secondary" variant="body2">
              <Typography
                component={'span'}
                color="secondary.main"
                variant="subtitle2"
              >
                Posted by:&nbsp;&nbsp;
                {!detail.confidential ? (
                  <Link
                    target="__blank"
                    href={getOldLink(
                      `/r/${detail?.recruiter?.recruiterId}-${kebabCase(
                        detail?.recruiter?.recruiterName.replace(/&/g, '-and-')
                      )}`
                    )}
                  >
                    {detail.recruiter.recruiterName},
                  </Link>
                ) : (
                  <Typography
                    component={'span'}
                    color={'primary.main'}
                    variant="subtitle2"
                  >
                    Verified Recruiter
                  </Typography>
                )}
              </Typography>{' '}
              {!detail.confidential && detail.recruiter.designation}
            </Typography>
          </Box>
        </Box>
        <Typography variant="subtitle1" fontSize={{xxs: 18}} mb={0.5} mt={3}>
          Review your Application
        </Typography>
      </Box>
    </Box>
  );
};

export const Footer = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const detail: JB = useSelector((state: AppState) => state.jobDetail);

  const onApply = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    props.onApply();
  };
  // const detail: JB = useSelector((state: AppState) => state.jobDetail);
  return (
    <Box
      display={'flex'}
      justifyContent={'flex-end'}
      alignItems={'center'}
      sx={{
        boxShadow: '0px 6.5px 6px 0px #2929290e inset',
        py: {xxs: 2, md: 3},
        px: {xxs: 1, md: 2},
        backgroundColor: '#fff',
        gap: 2,
        borderRadius: '16px 16px 0 0',
      }}
    >
      {/* <CheckboxLabel
        onChange={(value: boolean) => props.onChange({dontShow: value})}
        label={'Don’t Show me this again'}
      /> */}
      <ButtonV2
        onClick={() => {
          setTimeout(() => {
            if (isLoading) {
              console.log('Loading...');
              return;
            }

            onApply();

            TrackEventUBA('jdPageClick', 'click', {
              ref: getKeyFromPath('ref') || '',
              pageName: 'Job Description Page',
              jobID: detail.id,
              jobVersion: '',
              jobRef: getKeyFromPath('ref') || '',
              jobPos: getKeyFromPath('jobPos') || '',
              page: 'JD',
              section: 'ReviewAndSubmit',
              sessionUsername: sessionStorage.getItem('userId') || '',
            });
          }, 0);
        }}
        variant="contained"
        sx={{
          px: {xxs: 2, md: 3},
          py: {xxs: 1, md: 1},
          fontSize: {xxs: 14, md: 16},
          mr: 1,
          minWidth: {xxs: 166, md: 183},
          minHeight: {xxs: 37, md: 37},
        }}
        color="secondary"
        // disabled={isLoading}
      >
        {isLoading ? (
          <Loader sx={{color: '#fff'}} size={16} />
        ) : (
          'Review & Submit'
        )}
      </ButtonV2>
    </Box>
  );
};

export const Component = (props: any) => {
  const isLarge = useIsLargeDevice();
  let DialogComponent: any;
  if (isLarge) {
    DialogComponent = PopUpDialog;
    // DialogComponent = dynamic(() => import('./Dialog'));
  } else {
    DialogComponent = BottomSheetDialog;
    // DialogComponent = dynamic(
    //   () => import('@jobseeker/lotus/elements/BottomSheet')
    // );
  }

  const dispatch = useDispatch();

  // const [dialogState, setDialogState] = useState({});
  const onChange = (data: any) => {
    // console.log(data, {...dialogState, ...data});
    // setDialogState({...data});
    dispatch({
      type: 'User/set_profile_setting_coverletter',
      payload: data?.attachCover ? 1 : 0,
    });
    props.onChange(data);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onApply = () => {
    // props.onClose();
    props.onApply();
  };
  return (
    <DialogComponent
      open={props.open}
      header={
        <Header onClose={props.onClose} confidential={props.confidential} />
      }
      defaultSnap={({lastSnap, snapPoints}: any) =>
        lastSnap ?? Math.max(...snapPoints)
      }
      snapPoints={({maxHeight}: any) => [maxHeight - 50]}
      footer={<Footer onChange={onChange} onApply={props.onApply} />}
    >
      <ApplyJobInternal refInfo={props?.refInfo} onChange={onChange} />
    </DialogComponent>
  );
};

export default Component;
